export default __webpack_public_path__ + "static/media/Customers.d48acd5b.svg";